const mock = {
    class_name: 'CmonClusterInfo',
    cdt_path: '/',
    acl: 'user::rwx,group::rwx,other::---',
    tags: [],
    cluster_auto_recovery: true,
    cluster_id: 1,
    cluster_name: 'Mongo Shards',
    cluster_type: 'MONGODB',
    configuration_file: '/etc/cmon.d/cmon_1.cnf',
    effective_privileges: 'rwx',
    log_file: '/var/log/cmon_1.log',
    maintenance_mode_active: false,
    managed: true,
    node_auto_recovery: true,
    rpc_version: '2.0',
    state: 'STARTED',
    status_text: 'All nodes are operational.',
    vendor: 'percona',
    version: '4.0',
    alarm_statistics: {
        class_name: 'CmonAlarmStatistics',
        cluster_id: 1,
        created_after: null,
        critical: 0,
        reported_after: null,
        warning: 0,
    },
    group_owner: {
        class_name: 'CmonGroup',
        cdt_path: '/groups',
        owner_user_id: 1,
        owner_user_name: 'system',
        owner_group_id: 1,
        owner_group_name: 'admins',
        acl: 'user::rwx,group::rwx,other::---',
        created: '2022-02-02T13:11:15.734Z',
        group_id: 1,
        group_name: 'admins',
    },
    hosts: [
        {
            class_name: 'CmonMongoHost',
            cdt_path: '/cluster_1',
            owner_user_id: 1,
            owner_user_name: 'system',
            owner_group_id: 1,
            owner_group_name: 'admins',
            acl: 'user::rwx,group::rwx,other::---',
            clusterid: 1,
            cmdline: '/usr/bin/mongod --fork -f /etc/mongod.conf',
            configfile: '/etc/mongod.conf',
            connected: true,
            connections_available: 807,
            connections_current: 12,
            container: true,
            datadir: '/var/lib/mongodb',
            dbpath: '/var/lib/mongodb',
            global_lock_queue: 0,
            global_lock_ratio: 0,
            hidden: false,
            hostId: 2,
            hostname: '10.0.8.11',
            hoststatus: 'CmonHostOnline',
            ip: '10.0.8.11',
            lastseen: 1654794031,
            logfile: '/var/log/mongodb/mongod.log',
            maintenance_mode: 'none',
            maintenance_mode_active: false,
            member_role: 'Configsvr',
            message: 'Up and running',
            nodetype: 'mongo',
            os_user: 'mongod',
            pid: 8924,
            pidfile: '/var/run/mongod.pid',
            pingstatus: 1,
            pingtime: 58,
            port: 27019,
            priority: 1,
            replication_lag: 0,
            role: 'configsvr',
            roleid: 1,
            rs: 'replica_set_config',
            slaveDelay: 0,
            sshfailcount: 0,
            ssl_allowinvalidcert: false,
            ssl_mode: '',
            statereason: 'Primary',
            status: 1,
            timestamp: 1654794031,
            unique_id: 2,
            uptime: 19376,
            version: '4.0.28-23',
            wallclock: 1654794020,
            wallclocktimestamp: 1654794020,
            distribution: {
                name: 'ubuntu',
                codename: 'focal',
                release: '20.04',
                type: 'debian',
            },
            replication_slave: {
                seconds_behind_master: 0,
            },
            ssl_certs: {
                server: {
                    ca: '',
                    id: 0,
                    key: '',
                    path: '',
                    ssl_enabled: false,
                },
            },
        },
        {
            class_name: 'CmonMongoHost',
            cdt_path: '/cluster_1',
            owner_user_id: 1,
            owner_user_name: 'system',
            owner_group_id: 1,
            owner_group_name: 'admins',
            acl: 'user::rwx,group::rwx,other::---',
            clusterid: 1,
            cmdline: '/usr/bin/mongod --fork -f /etc/mongod.conf',
            configfile: '/etc/mongod.conf',
            connected: true,
            connections_available: 802,
            connections_current: 17,
            container: true,
            datadir: '/var/lib/mongodb',
            dbpath: '/var/lib/mongodb',
            global_lock_queue: 0,
            global_lock_ratio: 0,
            hidden: false,
            hostId: 3,
            hostname: '10.0.8.13',
            hoststatus: 'CmonHostOnline',
            ip: '10.0.8.13',
            lastseen: 1654794031,
            logfile: '/var/log/mongodb/mongod.log',
            maintenance_mode: 'none',
            maintenance_mode_active: false,
            member_role: 'Primary',
            message: 'Up and running',
            nodetype: 'mongo',
            os_user: 'mongod',
            pid: 8759,
            pidfile: '/var/run/mongod.pid',
            pingstatus: 1,
            pingtime: 43,
            port: 27018,
            priority: 1,
            replication_lag: 0,
            role: 'shardsvr',
            roleid: 0,
            rs: 'shard1',
            slaveDelay: 0,
            sshfailcount: 0,
            ssl_allowinvalidcert: false,
            ssl_mode: '',
            statereason: 'Primary',
            status: 1,
            timestamp: 1654794031,
            unique_id: 3,
            uptime: 19361,
            version: '4.0.28-23',
            wallclock: 1654794020,
            wallclocktimestamp: 1654794020,
            distribution: {
                name: 'ubuntu',
                codename: 'focal',
                release: '20.04',
                type: 'debian',
            },
            replication_slave: {
                seconds_behind_master: 0,
            },
            ssl_certs: {
                server: {
                    ca: '',
                    id: 0,
                    key: '',
                    path: '',
                    ssl_enabled: false,
                },
            },
        },
        {
            class_name: 'CmonMongoHost',
            cdt_path: '/cluster_1',
            owner_user_id: 1,
            owner_user_name: 'system',
            owner_group_id: 1,
            owner_group_name: 'admins',
            acl: 'user::rwx,group::rwx,other::---',
            clusterid: 1,
            cmdline: '/usr/bin/mongod --fork -f /etc/mongod.conf',
            configfile: '/etc/mongod.conf',
            connected: true,
            connections_available: 809,
            connections_current: 10,
            container: true,
            datadir: '/var/lib/mongodb',
            dbpath: '/var/lib/mongodb',
            global_lock_queue: 0,
            global_lock_ratio: 0,
            hidden: false,
            hostId: 4,
            hostname: '10.0.8.14',
            hoststatus: 'CmonHostOnline',
            ip: '10.0.8.14',
            lastseen: 1654794031,
            logfile: '/var/log/mongodb/mongod.log',
            maintenance_mode: 'none',
            maintenance_mode_active: false,
            member_role: 'Secondary',
            message: 'Up and running',
            nodetype: 'mongo',
            os_user: 'mongod',
            pid: 4278,
            pidfile: '/var/run/mongod.pid',
            pingstatus: 1,
            pingtime: 50,
            port: 27018,
            priority: 1,
            replication_lag: 0,
            role: 'shardsvr',
            roleid: 0,
            rs: 'shard1',
            slaveDelay: 0,
            sshfailcount: 0,
            ssl_allowinvalidcert: false,
            ssl_mode: '',
            statereason: 'Secondary',
            status: 2,
            timestamp: 1654794031,
            unique_id: 4,
            uptime: 19364,
            version: '4.0.28-23',
            wallclock: 1654794020,
            wallclocktimestamp: 1654794020,
            distribution: {
                name: 'ubuntu',
                codename: 'focal',
                release: '20.04',
                type: 'debian',
            },
            replication_slave: {
                seconds_behind_master: 0,
            },
            ssl_certs: {
                server: {
                    ca: '',
                    id: 0,
                    key: '',
                    path: '',
                    ssl_enabled: false,
                },
            },
        },
        {
            class_name: 'CmonMongoHost',
            cdt_path: '/cluster_1',
            owner_user_id: 1,
            owner_user_name: 'system',
            owner_group_id: 1,
            owner_group_name: 'admins',
            acl: 'user::rwx,group::rwx,other::---',
            clusterid: 1,
            cmdline: '/usr/bin/mongod --fork -f /etc/mongod.conf',
            configfile: '/etc/mongod.conf',
            connected: true,
            connections_available: 814,
            connections_current: 5,
            container: true,
            datadir: '/var/lib/mongodb',
            dbpath: '/var/lib/mongodb',
            global_lock_queue: 0,
            global_lock_ratio: 0,
            hidden: false,
            hostId: 5,
            hostname: '10.0.8.15',
            hoststatus: 'CmonHostOnline',
            ip: '10.0.8.15',
            lastseen: 1654794031,
            logfile: '/var/log/mongodb/mongod.log',
            maintenance_mode: 'none',
            maintenance_mode_active: false,
            member_role: 'Arbiter',
            message: 'Up and running',
            nodetype: 'mongo',
            os_user: 'mongod',
            pid: 4295,
            pidfile: '/var/run/mongod.pid',
            pingstatus: 1,
            pingtime: 54,
            port: 27018,
            priority: 0,
            role: 'arbiter',
            roleid: 3,
            rs: 'shard1',
            slaveDelay: 0,
            sshfailcount: 0,
            ssl_allowinvalidcert: false,
            ssl_mode: '',
            statereason: 'Arbiter',
            status: 7,
            timestamp: 1654794031,
            unique_id: 5,
            uptime: 19359,
            version: '4.0.28-23',
            wallclock: 1654794020,
            wallclocktimestamp: 1654794020,
            distribution: {
                name: 'ubuntu',
                codename: 'focal',
                release: '20.04',
                type: 'debian',
            },
            ssl_certs: {
                server: {
                    ca: '',
                    id: 0,
                    key: '',
                    path: '',
                    ssl_enabled: false,
                },
            },
        },
        {
            class_name: 'CmonMongoHost',
            cdt_path: '/cluster_1',
            owner_user_id: 1,
            owner_user_name: 'system',
            owner_group_id: 1,
            owner_group_name: 'admins',
            acl: 'user::rwx,group::rwx,other::---',
            clusterid: 1,
            cmdline: '/usr/bin/mongod --fork -f /etc/mongod.conf',
            configfile: '/etc/mongod.conf',
            connected: true,
            connections_available: 801,
            connections_current: 18,
            container: true,
            datadir: '/var/lib/mongodb',
            dbpath: '/var/lib/mongodb',
            global_lock_queue: 0,
            global_lock_ratio: 0,
            hidden: false,
            hostId: 6,
            hostname: '10.0.8.16',
            hoststatus: 'CmonHostOnline',
            ip: '10.0.8.16',
            lastseen: 1654794031,
            logfile: '/var/log/mongodb/mongod.log',
            maintenance_mode: 'none',
            maintenance_mode_active: false,
            member_role: 'Primary',
            message: 'Up and running',
            nodetype: 'mongo',
            os_user: 'mongod',
            pid: 4297,
            pidfile: '/var/run/mongod.pid',
            pingstatus: 1,
            pingtime: 46,
            port: 27018,
            priority: 1,
            replication_lag: 0,
            role: 'shardsvr',
            roleid: 0,
            rs: 'shard2',
            slaveDelay: 0,
            sshfailcount: 0,
            ssl_allowinvalidcert: false,
            ssl_mode: '',
            statereason: 'Primary',
            status: 1,
            timestamp: 1654794031,
            unique_id: 6,
            uptime: 19305,
            version: '4.0.28-23',
            wallclock: 1654794020,
            wallclocktimestamp: 1654794020,
            distribution: {
                name: 'ubuntu',
                codename: 'focal',
                release: '20.04',
                type: 'debian',
            },
            replication_slave: {
                seconds_behind_master: 0,
            },
            ssl_certs: {
                server: {
                    ca: '',
                    id: 0,
                    key: '',
                    path: '',
                    ssl_enabled: false,
                },
            },
        },
        {
            class_name: 'CmonMongoHost',
            cdt_path: '/cluster_1',
            owner_user_id: 1,
            owner_user_name: 'system',
            owner_group_id: 1,
            owner_group_name: 'admins',
            acl: 'user::rwx,group::rwx,other::---',
            clusterid: 1,
            cmdline: '/usr/bin/mongod --fork -f /etc/mongod.conf',
            configfile: '/etc/mongod.conf',
            connected: true,
            connections_available: 810,
            connections_current: 9,
            container: true,
            datadir: '/var/lib/mongodb',
            dbpath: '/var/lib/mongodb',
            global_lock_queue: 0,
            global_lock_ratio: 0,
            hidden: false,
            hostId: 7,
            hostname: '10.0.8.17',
            hoststatus: 'CmonHostOnline',
            ip: '10.0.8.17',
            lastseen: 1654794031,
            logfile: '/var/log/mongodb/mongod.log',
            maintenance_mode: 'none',
            maintenance_mode_active: false,
            member_role: 'Secondary',
            message: 'Up and running',
            nodetype: 'mongo',
            os_user: 'mongod',
            pid: 4280,
            pidfile: '/var/run/mongod.pid',
            pingstatus: 1,
            pingtime: 58,
            port: 27018,
            priority: 1,
            replication_lag: 0,
            role: 'shardsvr',
            roleid: 0,
            rs: 'shard2',
            slaveDelay: 0,
            sshfailcount: 0,
            ssl_allowinvalidcert: false,
            ssl_mode: '',
            statereason: 'Secondary',
            status: 2,
            timestamp: 1654794031,
            unique_id: 7,
            uptime: 19308,
            version: '4.0.28-23',
            wallclock: 1654794020,
            wallclocktimestamp: 1654794020,
            distribution: {
                name: 'ubuntu',
                codename: 'focal',
                release: '20.04',
                type: 'debian',
            },
            replication_slave: {
                seconds_behind_master: 0,
            },
            ssl_certs: {
                server: {
                    ca: '',
                    id: 0,
                    key: '',
                    path: '',
                    ssl_enabled: false,
                },
            },
        },
        {
            class_name: 'CmonMongoHost',
            cdt_path: '/cluster_1',
            owner_user_id: 5,
            owner_user_name: 'pablo',
            owner_group_id: 1,
            owner_group_name: 'admins',
            acl: 'user::rwx,group::rwx,other::---',
            clusterid: 1,
            cmdline: '/usr/bin/mongos --fork -f /etc/mongos.conf',
            configfile: '/etc/mongos.conf',
            connected: true,
            connections_available: 817,
            connections_current: 2,
            container: true,
            datadir: '/data/db',
            dbpath: '/data/db',
            global_lock_queue: 0,
            global_lock_ratio: 0,
            hostId: 8,
            hostname: '10.0.8.12',
            hoststatus: 'CmonHostOnline',
            ip: '10.0.8.12',
            lastseen: 1654794031,
            logfile: '/var/log/mongodb/mongos.log',
            maintenance_mode: 'none',
            maintenance_mode_active: false,
            member_role: 'Mongos',
            message: 'Up and running',
            nodetype: 'mongo',
            os_user: 'mongod',
            pid: 8810,
            pidfile: '/var/run/mongos.pid',
            pingstatus: 1,
            pingtime: 55,
            port: 27017,
            role: 'mongos',
            roleid: 2,
            rs: '',
            sshfailcount: 0,
            statereason: 'Mongos',
            status: 1,
            timestamp: 1654794031,
            unique_id: 8,
            uptime: 19342,
            version: '4.0.28-23',
            wallclock: 1654794020,
            wallclocktimestamp: 1654794020,
            distribution: {
                name: 'ubuntu',
                codename: 'focal',
                release: '20.04',
                type: 'debian',
            },
        },
        {
            class_name: 'CmonHost',
            cdt_path: '/cluster_1',
            owner_user_id: 5,
            owner_user_name: 'pablo',
            owner_group_id: 1,
            owner_group_name: 'admins',
            acl: 'user::rwx,group::rwx,other::---',
            clusterid: 1,
            configfile: '/etc/cmon.d/cmon_1.cnf',
            connected: true,
            container: false,
            hostId: 9,
            hostname: '134.122.121.181',
            hoststatus: 'CmonHostOnline',
            ip: '134.122.121.181',
            lastseen: 1654794017,
            logfile: '/var/log/cmon_1.log',
            maintenance_mode: 'none',
            maintenance_mode_active: false,
            message: 'Up and running.',
            nodetype: 'controller',
            pid: 1147,
            pingstatus: -1,
            pingtime: -1,
            port: 9500,
            role: 'controller',
            status: 10,
            timestamp: 1654794020,
            unique_id: 9,
            uptime: 186266,
            version: '1.9.4.5459',
            wallclock: 1654794020,
            wallclocktimestamp: 1654794020,
            distribution: {
                name: 'ubuntu',
                codename: 'focal',
                release: '20.04',
                type: 'debian',
            },
        },
    ],
    job_statistics: {
        class_name: 'CmonJobStatistics',
        cluster_id: 1,
        by_state: {
            ABORTED: 0,
            DEFINED: 0,
            DEQUEUED: 0,
            FAILED: 0,
            FINISHED: 0,
            RUNNING: 0,
        },
    },
    owner: {
        class_name: 'CmonUser',
        cdt_path: '/',
        owner_user_id: 5,
        owner_user_name: 'pablo',
        owner_group_id: 1,
        owner_group_name: 'admins',
        acl: 'user::rwx,group::r--,other::r--',
        created: '2022-03-24T13:24:02.244Z',
        disabled: false,
        email_address: 'pablo@localhost.xyz',
        first_name: 'pablo',
        last_failed_login: '',
        last_login: '2022-06-09T12:10:14.596Z',
        last_name: '',
        n_failed_logins: 0,
        origin: 'CmonDb',
        suspended: false,
        user_id: 5,
        user_name: 'pablo',
        groups: [
            {
                class_name: 'CmonGroup',
                cdt_path: '/groups',
                owner_user_id: 1,
                owner_user_name: 'system',
                owner_group_id: 1,
                owner_group_name: 'admins',
                acl: 'user::rwx,group::rwx,other::---',
                created: '2022-02-02T13:11:15.734Z',
                group_id: 1,
                group_name: 'admins',
            },
        ],
        timezone: {
            class_name: 'CmonTimeZone',
            name: 'Coordinated Universal Time',
            abbreviation: 'UTC',
            offset: 0,
            use_dst: false,
        },
    },
};
export default mock;
